/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';

// Components
import TicketlessTimeReportForm from 'components/models/time-report/forms/ticketless-time-report-form';
import SVG from 'components/widgets/icons/svg';


export default function ResolveWithTimeForm({ item: { setOpen }, ...props }) {
  return (
    <div className="triage-resolve-with-time-form">
      <div className="triage-option-form-header triage-option-header" onClick={() => setOpen(false)}>
        <SVG src="svg/time-report.svg" className="time-report triage-option-icon" />
        <span>Resolve with Time</span>
        <SVG src="svg/close.svg" className="close-triage-submenu" />
      </div>
      <TicketlessTimeReportForm className="triage-option-submenu" {...props} />
    </div>
  );
}

ResolveWithTimeForm.propTypes = {
  item: PropTypes.shape({
    setOpen: PropTypes.func
  })
};
